import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useLockBodyScroll } from 'react-use';
import { Notification } from '@che-ins-ui/notification';
import { useScreenSizes } from '@che-ins-ui/theme';
import { isSomeModalOpenSelector } from '@che-ins-ui/modal';
import AppLoader from './components/common/AppLoader';
import { SearchLayout, SuccessLayout } from './components/layouts';
import { ROUTES } from './components/routes';
import { OverlayLoaderModal } from './components/common/OverlayLoaderModal';
import { useInitialUrlCookie } from './libs/hooks/useInitialUrlCookie';
import { useMarketingParams } from './libs/hooks/useMarketingParams';
import { PageNotFound } from './components/TechnicalPages';
import { ThemeBackground } from './components/ThemeBackground/ThemeBackground';
import Insurance from './pages/order';
import Main from './pages';
const Success = lazy(() => import('./pages/success'));
const App = () => {
    const isSomeModalOpen = useSelector(isSomeModalOpenSelector);
    const { isMobile } = useScreenSizes();
    useInitialUrlCookie();
    useMarketingParams();
    useLockBodyScroll(!isMobile && isSomeModalOpen);
    return (_jsxs("div", { children: [_jsx(ThemeBackground, {}), _jsx(Suspense, { fallback: _jsx(AppLoader, {}), children: _jsxs(Routes, { children: [_jsx(Route, { path: '/', element: _jsx(Main, {}) }), _jsx(Route, { element: _jsx(SearchLayout, {}), children: _jsx(Route, { path: ROUTES.order, element: _jsx(Insurance, {}) }) }), _jsx(Route, { element: _jsx(SuccessLayout, {}), children: _jsx(Route, { path: `${ROUTES.success}/`, element: _jsx(Success, {}) }) }), _jsx(Route, { path: "*", element: _jsx(PageNotFound, {}) })] }) }), _jsx(OverlayLoaderModal, {}), _jsx(Notification, {})] }));
};
export default App;
